import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { NearMissReport } from './near-miss-report.model';




export class NearMissReportListItem {
    id: string = '';
    submissionDate: Date | null = null;
    submittedByName: string = '';
    injuryNearMiss: boolean | null = null;
    specifyOther: string = '';
    employeeFirstName: string = '';
    employeeLastName: string = '';
    dateOfBirth: Date | null = null;

    constructor(data?: Partial<NearMissReportListItem>) {
        if (data) {
            Object.assign(this, {
                ...data,
                submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
                dateOfBirth: data.dateOfBirth ? new Date(data.dateOfBirth) : null
            });
        }
    }



    static getTableColumns(): TableColumn[] {
        const columns: TableColumn[] = [];
        const instance = new NearMissReportListItem();
        const fieldMappings = NearMissReport.getFieldMappings();
        
        // Get all properties of the class
        Object.keys(instance).forEach(key => {
            // Skip the id property as it's handled separately
            if (key === 'id') return;

            // Determine the type based on the property value
            let type: 'text' | 'date' | 'action' | 'status' = 'text';
            const value = instance[key as keyof NearMissReportListItem];
            
            if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
                type = 'date';
            }
            // All other values default to 'text' type

            // Add the column if it has a mapping
            if (fieldMappings[key]) {
                columns.push({
                    key,
                    label: fieldMappings[key],
                    type,
                    sortable: true
                });
            }
        });

        // Add the action column at the end
        columns.push({
            key: 'action',
            label: 'View',
            type: 'action',
            width: '80px'
        });

        return columns;
    }

    static fromApiResponse(data: any): NearMissReportListItem {
        return new NearMissReportListItem({
            id: data.id,
            submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
            submittedByName: data.submittedByName,
            injuryNearMiss: data.injuryNearMiss,
            specifyOther: data.specifyOther,
            employeeFirstName: data.employeeFirstName,
            employeeLastName: data.employeeLastName,
            dateOfBirth: data.dateOfBirth ? new Date(data.dateOfBirth) : null
        });
    }
} 